module.exports = __webpack_public_path__ + "static/media/rRsi.4a343791.png";